export default __webpack_public_path__ + "static/media/camera.7dc8dad7.svg";